import { service } from "@ember/service";
import DiscourseRoute from "discourse/routes/discourse";
import { i18n } from "discourse-i18n";

export default class CirclesIndexRoute extends DiscourseRoute {
  @service("circles") circlesService;

  queryParams = {
    filter: { refreshModel: true, replace: true },
    type: { refreshModel: true },
    ...Object.fromEntries(
      this.circlesService.customFilters.map((filter) => [
        filter.queryParameter,
        { refreshModel: true },
      ])
    ),
  };

  titleToken() {
    return i18n("discourse_circles.index.title_token");
  }

  model(params) {
    return params;
  }

  setupController(controller, model) {
    super.setupController(controller, model);
    controller.loadCircles(model);
  }
}
